"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CardHeader_1 = require("./CardHeader");
exports.default = CardHeader_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/CardHeader/index.js
// module id = 1115
// module chunks = 8